import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Button,
} from "reactstrap";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonTable from "../../../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import { CertificateTableHeader } from "../../../../Data/Tables/ReactstrapTables/BasicTables";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl } from "../../../../Utils/Baseurl/Baseurl";
import { Btn } from "../../../../AbstractElements";
import { toast } from "react-toastify";
import { log } from "console";
import { Row } from "reactstrap";
import { jwtDecode } from "jwt-decode";

type Certificate = {
  gmpcertificate?: { path: string; filestatus: string };
  analysiscertificate?: { path: string; filestatus: string };
  quotation?: { path: string; filestatus: string };
  productpackagecoverorinsert?: { path: string; filestatus: string };
  batchtestingreport?: { path: string; filestatus: string };
  otherdocuments?: { path: string; filestatus: string };
};
interface OtherDetail {
  path: string;
  filename: string;
  // filestatus:string;
}
interface CertificateData {
  path: string;
  filename: string;
  filestatus: string;
}

const CertificateTable = () => {
  const navigate = useNavigate();
  const { tokenid } = useParams();
  const [certificateData, setCertificateData] = useState<CertificateData[]>([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [rejectionReasons, setRejectionReasons] = useState("");
  const [medicinename, setMedicineName] = useState("");
  const [contents, setContents] = useState("");
  const [quotation, setQuotation] = useState("");
  const [purchaserate, setPurchaserate] = useState("");
  const [chemical, setChemical] = useState("");
  const [mrp, setMrp] = useState("");
  const [description, setDescription] = useState("");
  const [indentForm, setIndentForm] = useState<string | null>(null);
  const [status, setStatus] = useState("");
  const [finalstatus, setFinalStatus] = useState("");
  const [rejectionstatus, setRejectionStatus] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [otherDetails, setOtherDetails] = useState<OtherDetail[]>([]);
  const [approvalModalOpen, setApprovalModalOpen] = useState(false);
  const certificateLabels: { [key: string]: string } = {
    gmpcertificate: "GMP Certificate",
    analysiscertificate: "Analysis Certificate",
    quotation: "Quotation",
    productpackagecoverorinsert: "Product Package Cover/Insert",
    batchtestingreport: "Batch Testing Report",
    otherdocuments: "Other Documents",
  };

  const fetchCertificates = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}medicinedetails/certificates/${tokenid}`
      );
      // console.log(response.data, "response");

      setMedicineName(response.data?.medicinename || "");
      setDescription(response.data?.description || "");
      setCertificateData(response.data?.certificates || {});
      setIndentForm(response.data?.indentform || "");
      setStatus(response.data?.status || "");
      setContents(response.data?.contents || []);
      setFinalStatus(response.data?.finalstatus || "");
      setRejectionReasons(
        Array.isArray(response.data?.rejectionDetails)
          ? response.data.rejectionDetails
          : []
      );
      setRejectionStatus(response.data?.rejectstatus || "");
      setQuotation(response.data.quotationno);
      setPurchaserate(response.data.purchaserate);
      setChemical(response.data.chemical);
      setMrp(response.data.mrp);
      setRejectionStatus(response.data.rejectstatus);
      setOtherDetails(response.data?.otherdetails || []);
    } catch (error) {
      console.error("Error fetching certificates:", error);
    }
  };

  useEffect(() => {
    if (tokenid) {
      fetchCertificates();
    }
  }, [tokenid]);

  const token = localStorage.getItem("token");
  if (!token) {
    toast.error("User is not logged in!");
    return null; // Ensure a valid JSX return type
  }

  const decoded = jwtDecode<{ id: string }>(token);
  const userId = decoded.id;
  if (!userId) {
    toast.error("Invalid token, user ID not found!");
    return null; // Ensure a valid JSX return type
  }
  // console.log(userId);

  const confirmApproval = async () => {
    try {
      await axios.put(
        `${baseUrl}medicinedetails/certificates/status/${tokenid}`,
        { status: 1, userId }
      );
      toast.success("Certificate Approved Successfully");
      await fetchCertificates();
      setApprovalModalOpen(false); // Close the modal
      setTimeout(
        () => navigate(`${process.env.PUBLIC_URL}/weeklybooking`),
        2000
      );
    } catch (error) {
      console.error("Error approving certificate:", error);
    }
  };

  const handleReject = () => {
    setModalOpen(true); // Open modal when Reject button is clicked
  };

  const submitRejection = async () => {
    try {
      await axios.put(
        `${baseUrl}medicinedetails/certificates/status/${tokenid}`,
        {
          status: 2,
          reason: rejectionReason,
          userId,
        }
      );
      toast.success("Certificate Rejected Successfully");
      setModalOpen(false);

      // Navigate AFTER the rejection is successfully submitted
      setTimeout(
        () => navigate(`${process.env.PUBLIC_URL}/weeklybooking`),
        2000
      );
    } catch (error) {
      console.error("Error rejecting certificate:", error);
    }
  };

  // single file approve
  const handleCertificateApproval = async (certificateKey: string) => {
    if (!tokenid) return;
    try {
      await axios.post(`${baseUrl}medicinedetails/approve-certificate`, {
        tokenid,
        certificateKey,
        filestatus: "1"
      });
      toast.success(
        `${
          certificateLabels[certificateKey] || certificateKey
        } Approved Successfully`
      );
      fetchCertificates(); // Refresh data after approval
    } catch (error) {
      console.error("Error approving certificate:", error);
      toast.error("Approval failed");
    }
  };

  // single file reject
  const handleCertificateRejection = async (certificateKey: string) => {
    if (!tokenid) return;
    try {
      await axios.post(`${baseUrl}medicinedetails/reject-certificate`, {
        tokenid,
        certificateKey,
      });
      toast.success(
        `${
          certificateLabels[certificateKey] || certificateKey
        } Rejected Successfully`
      );
      fetchCertificates(); // Refresh data after rejection
    } catch (error) {
      console.error("Error rejecting certificate:", error);
      toast.error("Rejection failed");
    }
  };

  const allCertificatesApproved =
    certificateData &&
    Object.keys(certificateData).length > 0 &&
    Object.values(certificateData).every((file) => file.filestatus === "1");


  return (
    <>
      <Col sm={12}>
        <Card>
          <CommonCardHeader title="Medicine Details" />
          <div className="table-responsive">
            <Card className="p-3 ps-5 bg-light text-dark mx-5">
              {/* Medicine Name */}
              <Row className="padding">
                <Col md={2} className="fw-bold text-start">
                  Medicine Name
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp; {medicinename}
                </Col>
                <Col md={2} className="fw-bold text-start">
                  Quantity
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp; {quotation}
                </Col>
              </Row>
              {/* Description */}
              <Row className="padding">
                <Col md={2} className="fw-bold text-start">
                  Description
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp;{description}
                </Col>
                <Col md={2} className="fw-bold text-start">
                  Purchase Rate
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp;
                  {purchaserate !== "" ? purchaserate : ""}
                </Col>
              </Row>
              {/* Contents */}
              <Row className="padding">
                <Col md={2} className="fw-bold text-start">
                  Contents in gm
                </Col>
                <Col md={4} className="text-start">
                  {Array.isArray(contents) && contents.length > 0 ? (
                    <ul className="m-0 p-0">
                      {contents.map((item, index) => (
                        <li key={index}>
                          <Row>
                            <Col md={6} className="text-start">
                              :&nbsp;&nbsp;&nbsp;&nbsp;{item.name}
                            </Col>
                            <Col md={6} className="text-start">
                              -&nbsp;&nbsp;{item.quantity}gm
                            </Col>
                          </Row>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span>{contents || "No contents available"}</span>
                  )}
                </Col>

                <Col md={2} className="fw-bold text-start">
                  MRP
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp; {mrp}
                </Col>
              </Row>
            </Card>
          </div>

          <div className="table-responsive">
            <CommonTable headData={CertificateTableHeader}>
              {certificateData ? (
                <>
                  {Object.entries(certificateData).map(([key, file], index) => (
                    <tr key={index}>
                      <th scope="row">{index + 1}</th>
                      <td>{certificateLabels[key] || key}</td>
                      <td>
                        <a
                          href={`${baseUrl}${file.path}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                         {file.filename}
                        </a>
                      </td>
                      <td>
                        {file.filestatus === "0" ? (
                          <>
                            <Button
                              color="success"
                              size="sm"
                              className="me-2"
                              onClick={() => handleCertificateApproval(key)}
                            >
                              Approve
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleCertificateRejection(key)}
                            >
                              Reject
                            </Button>
                          </>
                        ) : file.filestatus === "1" ||file.filestatus === "3" ? (
                          <span className="text-success fw-bold">Approved</span>
                        ) : (
                          <span className="text-danger fw-bold">Rejected</span>
                        )}
                      </td>
                    </tr>
                  ))}

                  {indentForm && (
                    <tr>
                      <th scope="row">
                        {Object.keys(certificateData).length + 1}
                      </th>
                      <td>Indent Form</td>
                      <td>
                        <a
                          href={`${baseUrl}${indentForm}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                           {/* {key.filename} */}
                          View Indent Form
                        </a>
                      </td>
                    </tr>
                  )}

                  {otherDetails.length > 0 && (
                    <>
                      <tr>
                        <th colSpan={3} className="text-center fw-bold fs-6">
                          Supporting Documents
                        </th>
                      </tr>
                      {otherDetails.map((file, index) => (
                        <tr key={index}>
                          <th scope="row">
                            {Object.keys(certificateData).length + 2 + index}
                          </th>
                          <td>Document {index + 1}</td>
                          <td>
                            <a
                              href={`${baseUrl}${file.path}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {file.filename}
                            </a>
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </>
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    No certificates available
                  </td>
                </tr>
              )}
            </CommonTable>
          </div>

          {/* Action Buttons */}
          <div className="d-flex gap-3" style={{ marginTop: "10px" }}>
            {(Number(status) === 0 || Number(status) === 2) &&
              Number(finalstatus) === 0 && (
                <>
                  {allCertificatesApproved && (
                    <Btn onClick={() => setApprovalModalOpen(true)}>
                      Approve
                    </Btn>
                  )}
                  <Btn onClick={handleReject}>Reject</Btn>
                </>
              )}
          </div>

          {/* Rejection Reasons */}
          {Array.isArray(rejectionReasons) && rejectionReasons.length > 0 && (
            <div className="mt-3 p-3 bg-light border rounded m-5">
              <table className="table table-bordered mt-2">
                <thead>
                  <tr>
                    <th>Rejected By</th>
                    <th>Reject Reason</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {rejectionReasons.map((reason, index) => {
                    // Determine who rejected it
                    let rejectedBy = "Unknown";
                    if (reason.status === 2) {
                      rejectedBy = "Purchase Team";
                    }
                    if (reason.finalstatus === 2) {
                      rejectedBy = "Purchase Manager";
                    }

                    // Get rejection reason
                    const rejectionText =
                      reason.rejectstatus && reason.rejectstatus.trim()
                        ? reason.rejectstatus
                        : reason.rejectreason && reason.rejectreason.trim()
                        ? reason.rejectreason
                        : "No reason provided";

                    // Format the rejectedAt date
                    const rejectedAtText = reason.rejectedAt
                      ? new Date(reason.rejectedAt).toLocaleString()
                      : "Date not available";

                    return (
                      <tr key={index}>
                        <td className="text-danger">{rejectedBy}</td>
                        <td className="text-danger">
                          <strong>{rejectionText}</strong>
                        </td>
                        <td className="text-danger">{rejectedAtText}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </Card>

        {/* Reject Reason Modal */}
        <Modal isOpen={modalOpen} backdrop="static" keyboard={false}>
          <ModalHeader>
            <div className="d-flex justify-content-between align-items-center w-100">
              <span>Reject Certificate</span>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setModalOpen(false)}
              ></button>
            </div>
          </ModalHeader>
          <ModalBody>
            <label>Reason for Rejection:</label>
            <Input
              type="textarea"
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
            />
            <div className="mt-3 d-flex justify-content-end">
              <Btn onClick={submitRejection} color="danger">
                Submit
              </Btn>
            </div>
          </ModalBody>
        </Modal>

        {/* Approval Confirmation Modal */}
        <Modal isOpen={approvalModalOpen} backdrop="static" keyboard={false}>
          <ModalHeader toggle={() => setApprovalModalOpen(false)}>
            Approve Certificate
          </ModalHeader>
          <ModalBody>Are you sure you want to approve this medicine?</ModalBody>
          <div className="modal-footer">
            <Btn onClick={() => setApprovalModalOpen(false)}>Cancel</Btn>
            <Btn onClick={confirmApproval} color="primary">
              Yes, Approve
            </Btn>
          </div>
        </Modal>
      </Col>
    </>
  );
};

export default CertificateTable;
